import { NgModule } from '@angular/core';

import { reducers, relationRelationFeatureKey } from '@app/modules/relation-relation/reducers';
import { RelationRelationEffects } from '@app/modules/relation-relation/effects/relation-relation.effects';
import { RelationRelationRoutingModule } from '@app/modules/relation-relation/relation-relation-routing.module';
import { SharedModule } from '@app/shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { RelationRelationTablePartComponent } from '@app/modules/relation-relation/components/relation-activity-overview-table/relation-relation-overview-table.component';
import { RelationRelationTableComponent } from '@app/modules/relation-relation/components/relation-activity-overview/relation-relation-overview.component';
import { RelationRelationCreateModalComponent } from '@app/modules/relation-relation/components/relation-activity-create-modal/relation-relation-create-modal.component';
import { RelationRelationDropdownComponent } from '@app/modules/relation-relation/components/relation-relation-dropdown/relation-relation-dropdown.component';

const COMPONENTS = [RelationRelationTablePartComponent, RelationRelationTableComponent, RelationRelationCreateModalComponent, RelationRelationDropdownComponent];

const IMPORTS = [
    SharedModule,
    RelationRelationRoutingModule,
    NzDividerModule,
    StoreModule.forFeature(relationRelationFeatureKey, reducers),
    EffectsModule.forFeature([RelationRelationEffects]),
];

@NgModule({
    exports: [COMPONENTS],
    declarations: [COMPONENTS],
    imports: [IMPORTS],
    providers: [],
})
export class RelationRelationModule {}
